import application from 'application/application';

import moment from 'moment';

application

	.directive('ngDateSameOrAfter', () => ({
		require: 'ngModel',
		scope: {
			ngDateSameOrAfter: '='
		},
		link(scope, element, attrs, controller) {

			var format = attrs.ngDateFormat || 'DD/MM/YYYY';

			controller.$validators.dateSameOrAfter = modelValue => {

				if (controller.$isEmpty(modelValue) || !scope.ngDateSameOrAfter)

					return true;

				return moment(modelValue, format, true).isSameOrAfter(moment(scope.ngDateSameOrAfter, format, true));

			};

		}
	}));
